import V from 'voUtils/V.js';
export default {
	data: {
		selectedImageIndex: undefined,
		openstreetmap: false,
		blogtag: 'Alles anzeigen',
		searchParams: {},
		themen: true
	},

	beforeMount: function () {
		var url = new URL(window.location.href);
		var pathname = url.pathname;
		var params = {};

		for (let key of url.searchParams.keys()) {
			params[key] = url.searchParams.get(key);
		}

		this.searchParams = params;

		var blogIndex = pathname.indexOf('/blog');

		if (blogIndex !== -1) {
			var afterBlog = pathname.substring(blogIndex + 5);

			if (afterBlog) {
				this.themen = false;
			} else {
				this.themen = true;
			}
		}
	},

	computed: {},

	methods: {}


};